import { render, staticRenderFns } from "./TitleBarHome.vue?vue&type=template&id=e31ffa84"
import script from "./TitleBarHome.vue?vue&type=script&lang=js"
export * from "./TitleBarHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports